var Choice = /** @class */ (function () {
    function Choice() {
    }
    return Choice;
}());
export default Choice;
var FileChoice = /** @class */ (function () {
    function FileChoice(url, download, image, mimeType) {
        if (url === void 0) { url = ""; }
        this.url = url;
        this.download = download;
        this.image = image;
        this.mimeType = mimeType;
    }
    return FileChoice;
}());
export { FileChoice };
var FilesChoice = /** @class */ (function () {
    function FilesChoice(sources, image) {
        this.sources = sources;
        this.image = image;
    }
    return FilesChoice;
}());
export { FilesChoice };
var StreamChoice = /** @class */ (function () {
    function StreamChoice(representations, image) {
        if (representations === void 0) { representations = []; }
        this.representations = representations;
        this.image = image;
    }
    return StreamChoice;
}());
export { StreamChoice };
var MessageChoice = /** @class */ (function () {
    function MessageChoice(text) {
        if (text === void 0) { text = ""; }
        this.text = text;
    }
    return MessageChoice;
}());
export { MessageChoice };
